"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BuildingsOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M23,26a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0V25A1,1,0,0,1,23,26Z"/><path d="M26.72,6.82,14.36,2.07a1,1,0,0,0-.93.11A1,1,0,0,0,13,3v9H6a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V8.69A2,2,0,0,0,26.72,6.82ZM6,28V14h9V28Zm20,0H17V14a2,2,0,0,0-2-2V4.46L26,8.69Z"/><rect x="18" y="9" width="2" height="17" rx="1"/><rect x="8" y="16" width="5" height="2" rx="1"/><rect x="8" y="20" width="5" height="2" rx="1"/><rect x="8" y="24" width="5" height="2" rx="1"/>';
var BuildingsOutlineSVG = function BuildingsOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BuildingsOutlineSVG = BuildingsOutlineSVG;
BuildingsOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BuildingsOutlineSVG);
exports.default = _default;